const defaultState = {
    product: {},
};

const mutations = {
    setProductState(state, product) {
        state.product = product;
    },
    resetProductState(state) {
        state.product = {};
    },
};

const actions = {
    async getProductInfo({ commit, dispatch }, productId) {
        try {
            const { data } = await this.$rq.getProduct(productId, { showallattributes: true });
            commit('setProductState', data);
        } catch (err) {
            dispatch('resetProductInfo');
        }
    },
    async getSiteProductInfo({ commit, dispatch }, { siteId, productId }) {
        try {
            const { data } = await this.$rq.getSiteProduct(siteId, productId);
            commit('setProductState', data);
        } catch (err) {
            dispatch('resetProductInfo');
        }
    },
    async getClientProductInfo({ commit, dispatch }, { clientId, productId }) {
        try {
            const { data } = await this.$rq.getClientProduct(clientId, productId);
            commit('setProductState', data);
        } catch (err) {
            dispatch('resetProductInfo');
        }
    },
    resetProductInfo({ commit }) {
        commit('resetProductState');
    },
};

const getters = {
    /**
     * "Flat" the file list in root object
     *
     * @param {Object} state
     * @return {Object} the product
     */
    product: ({ product }) => {
        const { files, ...props } = product;

        return {
            ...props,
            ...files,
        };
    },
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
